import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import SurveyTemplateDetailQuestion from './SurveyTemplateDetailQuestion';

const SurveyTemplateDetailModal = (props) => (
  <div className='survey-template-detail-modal'>
    <Modal isOpen={props.modal} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>{props.selectedTemplate ? props.selectedTemplate.name : 'Blank Survey'}</ModalHeader>
      <ModalBody>
        {props.questionAttributes && props.questionAttributes.length ?
          props.questionAttributes.map(questionAnswers =>
            <SurveyTemplateDetailQuestion
              questionAnswers={questionAnswers}
              key={questionAnswers.survey_template_question_id}
            />
          ) : <div>No question available for this template.</div>}
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-primary'
          onClick={() => props.useTemplate(props.selectedTemplate)}
        >
          {props.isTemplateSelected(props.selectedTemplate && props.selectedTemplate.id || null) ? 'Unselect template' : 'Use this template'}
            </button>
      </ModalFooter>
    </Modal>
  </div>
);

export default SurveyTemplateDetailModal;



// WEBPACK FOOTER //
// ./src/components/customSurvey/SurveyTemplateDetailModal.js